module.exports = __webpack_public_path__ + "static/media/green_line_why.4d2dd540.svg";